<!-- 封装日历组件 -->
<template>
  <vanPopup
    v-model="show"
    :position="position"
    :round="round"
    :duration="duration"
    :safe-area-inset-bottom="safeAreaInsetBottom"
    :style="{ height: height }"
  >
  <vanDatetimePicker
    v-model="currentDate"
    :type="type"
    :title="title"
    :min-date="minDate"
    :max-date="maxDate"
    :formatter="formatter"
    @cancel="cancel"
    @confirm="confirm"
  ></vanDatetimePicker>
  </vanPopup>
</template>

<script>
export default {
  name: 'dateTimePicker',
  props: {
    value: {
      type: Date,
      default() {
        return new Date()
      }
    },
    /** 弹窗类属性 */
    // 弹窗方向
    position: {
      type: String,
      default: 'bottom'
    },
    // 是否圆角
    round: {
      type: Boolean,
      default: true
    },
    // 弹窗高度
    height: {
      type: String,
      default: 'auto'
    },
    // 弹窗时间
    duration: {
      type: String,
      default: '0.3'
    },
    // 是否适配底部安全区域
    safeAreaInsetBottom: {
      type: Boolean,
      default: false
    },
    /** 日历类属性 */
    // 日历类型
    type: {
      type: String,
      default: 'datetime'
    },
    // 日历标题
    title: {
      type: String,
      default: ''
    },
    // 日期下限
    minDate: {
      type: Date,
      default() {
        return new Date(2019, 6, 1)
      }
    },
    // 日期上限
    maxDate: {
      type: Date,
      default() {
        return new Date()
      }
    },
    // 格式化
    formatter: {
      type: Function,
      default(type, val) {
        return val
      }
    }
  },
  watch: {
    value: {
      handler(val) {
        this.currentDate = new Date(val)
      },
      immediate: true,
      deep: true
    }
  },
  data() {
    return {
      show: false,
      currentDate: ''
    }
  },
  methods: {
    cancel() {
      this.show = false
    },
    showPopup() {
      this.show = true
    },
    confirm(date) {
      this.show = false
      this.$emit('input', date)
      this.$emit('confirm', date)
    }
  }
}
</script>
